import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  enoughToCompleted: false,
};

const completedSettings = createSlice({
  name: 'completedSettings',
  initialState,
  reducers: {
    setEnoughToCompleted: (state, action) => {
      state.enoughToCompleted = action.payload;
    },
  },
});

export const { setEnoughToCompleted } = completedSettings.actions;
export default completedSettings.reducer;
